/**
 * Live-input mask for percentage fields: digits and a single decimal point only,
 * truncated to at most two decimal digits. No range clamping here — 0-100 is
 * enforced separately by validateSetupForm on blur/submit.
 */
export const sanitizePercentageInput = (raw: string): string => {
  let value = raw.replace(/[^0-9.]/g, '');

  const firstDot = value.indexOf('.');
  if (firstDot !== -1) {
    const decimalPart = value.slice(firstDot + 1).replace(/\./g, '');
    value = value.slice(0, firstDot + 1) + decimalPart;
    const [intPart, decPart] = value.split('.');
    value = intPart + '.' + decPart.slice(0, 2);
  }

  return value;
};
